<template>
  <div
    @click="
      ($event) => {
        if (this.$listeners.click) {
          this.$listeners.click($event);
        }
      }
    "
    class="vb-icon"
    :class="dotted ? 'vb-icon--dotted' : ''"
    :style="`--size:${size}px; --dot-size:${dot_size}px; --color: ${
      color_ui.includes('--')
        ? 'var(' + color_ui + ')'
        : '#' + color_ui.replace('#', '')
    }; ${Object.entries(icon_style).map(
      (entry) => ` ${entry[0]}: ${entry[1]}; `,
    )}`"
    v-html="Icons[name.replace('-', '_')]"
  >
  </div>
</template>

<script>
import * as DesignIcons from "./design-icons";
import * as CreditCards from "./credit-cards";
import * as CustomIcons from "./custom-icons";

export default {
  name: "vb-icon",
  props: {
    name: String,
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "000000",
    },
    dotted: Boolean,
    dot_size: {
      type: Number,
      default: 10,
    },
    icon_style: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      color_ui: this.color,
      color_map: {
        primary: this.sass("primary"),
        secondary: this.sass("secondary"),
        info: this.sass("info"),
      },
    };
  },
  created() {
    this.Icons = {
      ...DesignIcons,
      ...CreditCards,
      ...CustomIcons,
    };
  },
  watch: {
    color(new_color) {
      this.color_ui = new_color;
      this.check_body_class();
    },
  },
  mounted() {
    if (this.check_body_class()) return;
    this.observe_customizations();
  },
  destroyed() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    observe_customizations() {
      const observer = new MutationObserver(() => {
        this.check_body_class();
      });
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
      this.observer = observer;
    },
    check_body_class() {
      const is_customized = document.body.classList.contains("customized");
      if (is_customized) {
        if (this.color === this.color_map.primary)
          this.color_ui =
            this.get_config('guiSettings.customizations.colors.primary', this.color);
        if (this.color === this.color_map.secondary)
          this.color_ui =
            this.get_config('guiSettings.customizations.colors.secondary', this.color);
        if (this.color === this.color_map.info)
          this.color_ui =
            this.get_config('guiSettings.customizations.colors.info', this.color);
      }
      return is_customized;
    },
  },
};
</script>

<style lang="scss">
.vb-icon {
  svg {
    width: var(--size);
    height: var(--size);
  }

  &--dotted {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      width: var(--dot-size);
      height: var(--dot-size);
      background-color: var(--secondary);
      border-radius: 100%;
    }
  }
}
</style>
